export function useRecaptcha() {
    const siteKey = window.appConfig.RECAPTCHA_SITE_KEY;

    const loadRecaptcha = () => {
        return new Promise((resolve, reject) => {
            if (window.grecaptcha) {
                resolve(window.grecaptcha);
                return;
            }

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.onload = () => {
                if (window.grecaptcha) {
                    resolve(window.grecaptcha);
                } else {
                    reject(new Error('reCAPTCHA failed to load'));
                }
            };
            script.onerror = () => {
                reject(new Error('reCAPTCHA script failed to load'));
            };
            document.head.appendChild(script);
        });
    };

    const generateRecaptchaToken = async (action) => {
        const grecaptcha = await loadRecaptcha();

        return new Promise((resolve, reject) => {
            grecaptcha.ready(() => {

                grecaptcha.execute(siteKey, { action })
                    .then(token => {
                        if (token) {
                            resolve(token);
                        } else {
                            reject(new Error('reCAPTCHA token generation failed'));
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        });
    };

    return {
        generateRecaptchaToken
    };
}